import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ErrorTooltipHelperComponent {
  focusTooltipContent(element: HTMLCollection) {
    if (element?.length > 0) {
      element[0].removeAttribute('tabindex');
    }
  }

  containedInIconButton(target: HTMLElement): boolean {
    return (
      (
        (<HTMLElement>target)?.parentNode?.parentNode?.parentNode as HTMLElement
      ).getAttribute('class') === 'iconButton'
    );
  }

  containsInHelpIcon(target: HTMLElement): boolean {
    return (
      ((<HTMLElement>target)?.parentNode as HTMLElement).getAttribute(
        'class'
      ) === 'idp-icon-info-anchor'
    );
  }

  isModalDialog(eventTarget: EventTarget): boolean {
    const element = eventTarget as HTMLElement;
    return (
      element.nextElementSibling !== null &&
      element.nextElementSibling.outerHTML.includes('modal-dialog')
    );
  }

  isExitButton(eventTarget: EventTarget): boolean {
    const element = eventTarget as HTMLElement;
    return (
      element.parentElement !== null &&
      element.parentElement.className.trim() === 'exit-button'
    );
  }

  isConfirmationButton(eventTarget: EventTarget): boolean {
    const element = eventTarget as HTMLElement;
    return (
      element.textContent !== null &&
      element.textContent.trim() === 'CONTINUE TO CONFIRMATION'
    );
  }

  isInfoIcon(eventTarget: EventTarget): boolean {
    const element = eventTarget as HTMLElement;
    return (
      element?.className?.includes('idp-icon-info') ||
      element?.className === 'idp-icon-info-anchor'
    );
  }

  isDialogRelatedEvent(target: any) {
    return (
      this.isModalDialog(target) ||
      this.isExitButton(target) ||
      this.isConfirmationButton(target)
    );
  }
}
